import { render } from "./SingleClass.vue?vue&type=template&id=2d9bcd04&scoped=true"
import script from "./SingleClass.vue?vue&type=script&lang=js"
export * from "./SingleClass.vue?vue&type=script&lang=js"

import "./SingleClass.vue?vue&type=style&index=0&id=2d9bcd04&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc\\Documents\\projets\\school_app_front_novation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9bcd04"]])

export default __exports__